/**
 * Detects whether a string is primarily RTL (Arabic, Hebrew, etc.) or LTR.
 * Returns 'rtl' if ≥ 30% of alphabetic characters are RTL script, else 'ltr'.
 */
const RTL_REGEX = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0590-\u05FF]/g;
const ALPHA_REGEX = /[a-zA-Z\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0590-\u05FF]/g;

export function detectTextDirection(text: string | null | undefined): 'ltr' | 'rtl' {
  if (!text) return 'ltr';
  const alphaChars = text.match(ALPHA_REGEX);
  if (!alphaChars || alphaChars.length === 0) return 'ltr';
  const rtlChars = text.match(RTL_REGEX);
  const rtlCount = rtlChars?.length ?? 0;
  return rtlCount / alphaChars.length >= 0.3 ? 'rtl' : 'ltr';
}

/**
 * Samples multiple strings and returns direction based on overall density.
 */
export function detectContentDirection(...texts: (string | null | undefined)[]): 'ltr' | 'rtl' {
  const combined = texts.filter(Boolean).join(' ');
  return detectTextDirection(combined);
}
